<template>
	<section class="production-quote hideme">
		<div class="item">
			<div class="quote top"><img src="https://res.cloudinary.com/dwmmozjrb/image/upload/v1627839187/three-bb/quote-top.png" alt="quote"></div>
			<div>
				<p style="text-align: center">{{prodQuote.text}}</p>
			</div>
			<div class="quote bottom"><img src="https://res.cloudinary.com/dwmmozjrb/image/upload/v1627839187/three-bb/quote-bottom.png" alt="quote"></div>
			<div class="byline">{{prodQuote.author}}</div>
		</div>
	</section>
</template>


<script>
	export default {
		name:'production-quote',
		props: {
			prodQuote: {
				required: false,
				type: Object
			}
		},
		data: function() {
			return {}
		},
		methods: {
		},
		mounted: function() {
		}
	}
</script>


// WEBPACK FOOTER //
// ProductionQuote.vue?25fadcc1